import {Component} from "@angular/core";
import {provideReportModel} from "@fedeltapointofsale/data-client";
import {ConsolidationReportModel} from "./consolidation-report.model";
import {AbstractReportPage} from "../../../framework/entity/report/report-page/abstract-report-page";

@Component({
    selector: "wbo-consolidation-report",
    templateUrl: "./consolidation-report.component.html",
    providers: [provideReportModel(ConsolidationReportModel)]
})

export class ConsolidationReportComponent extends AbstractReportPage {
    constructor(public model: ConsolidationReportModel) {
        super();
    }
}
